import MuiDialogContent from "@material-ui/core/DialogContent";
import React from "react";
export interface DialogContentProps {
    className?: string;
    children: React.ReactNode;
}
export function DialogContent({ className, children }: DialogContentProps) {
    return <MuiDialogContent className={className}>{children}</MuiDialogContent>;
}
